/** API client functions for account management. */

import { apiGet, apiPatch, apiPost, apiDelete } from '@/api/client';

export interface LinkedProvider {
  providerName: string;
  providerType: string;
  linkedAt?: string;
}

export interface UserProfile {
  userId: string;
  email: string;
  name: string;
  picture?: string;
  linkedProviders: LinkedProvider[];
}

export async function getProfile(): Promise<UserProfile> {
  return apiGet<UserProfile>('/account/profile');
}

export async function updateProfile(data: { name?: string }): Promise<UserProfile> {
  return apiPatch<UserProfile>('/account/profile', data);
}

export async function getLinkedProviders(): Promise<LinkedProvider[]> {
  const response = await apiGet<{ providers: LinkedProvider[] }>('/account/providers');
  return response.providers;
}

export async function initiateLink(
  providerName: string,
): Promise<{ authUrl: string }> {
  return apiPost<{ authUrl: string }>('/account/providers/link', {
    providerName,
  });
}

export async function unlinkProvider(providerName: string): Promise<void> {
  return apiDelete(`/account/providers/${encodeURIComponent(providerName)}`);
}
